// extracted by mini-css-extract-plugin
module.exports = {"caption":"solutions1_caption__RQA4U","caption2":"solutions1_caption2__1pDJq","container":"solutions1_container__1ybvZ"};